var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var _animate;
import { yieldToMainThread } from "@theme/utilities";
import { Component } from "@theme/component";
class FlyToCart extends Component {
  constructor() {
    super(...arguments);
    /** @type {Element} */
    __publicField(this, "source");
    /** @type {boolean} */
    __publicField(this, "useSourceSize", false);
    /** @type {Element} */
    __publicField(this, "destination");
    /**
     * Animates the flying thingy along the bezier curve.
     * @param {DOMRectReadOnly} sourceRect - The bounding client rect of the source.
     * @param {DOMRectReadOnly} destinationRect - The bounding client rect of the destination.
     */
    __privateAdd(this, _animate, async (sourceRect, destinationRect) => {
      const startPoint = {
        x: sourceRect.left + sourceRect.width / 2,
        y: sourceRect.top + sourceRect.height / 2
      };
      const endPoint = {
        x: destinationRect.left + destinationRect.width / 2,
        y: destinationRect.top + destinationRect.height / 2
      };
      if (this.useSourceSize) {
        this.style.setProperty("--width", "".concat(sourceRect.width, "px"));
        this.style.setProperty("--height", "".concat(sourceRect.height, "px"));
      }
      this.style.setProperty("--start-x", "".concat(startPoint.x, "px"));
      this.style.setProperty("--start-y", "".concat(startPoint.y, "px"));
      this.style.setProperty("--travel-x", "".concat(endPoint.x - startPoint.x, "px"));
      this.style.setProperty("--travel-y", "".concat(endPoint.y - startPoint.y, "px"));
      await yieldToMainThread();
      const animations = typeof this.getAnimations === "function" ? this.getAnimations() : [];
      const animationPromises = animations.map((animation) => animation.finished);
      if (typeof Promise.allSettled === "function") {
        await Promise.allSettled(animationPromises);
      } else {
        await Promise.all(animationPromises.map((promise) => Promise.resolve(promise).then(
          (value) => ({ status: "fulfilled", value }),
          (reason) => ({ status: "rejected", reason })
        )));
      }
      this.remove();
    });
  }
  connectedCallback() {
    super.connectedCallback();
    const intersectionObserver = new IntersectionObserver((entries) => {
      let sourceRect = null;
      let destinationRect = null;
      entries.forEach((entry) => {
        if (entry.target === this.source) {
          sourceRect = entry.boundingClientRect;
        } else if (entry.target === this.destination) {
          destinationRect = entry.boundingClientRect;
        }
      });
      if (sourceRect && destinationRect) {
        __privateGet(this, _animate).call(this, sourceRect, destinationRect);
      }
      intersectionObserver.disconnect();
    });
    intersectionObserver.observe(this.source);
    intersectionObserver.observe(this.destination);
  }
}
_animate = new WeakMap();
if (!customElements.get("fly-to-cart")) {
  customElements.define("fly-to-cart", FlyToCart);
}
